import React, { ReactNode } from "react";

import { SupHeading, SupText } from "@repo/core-ui";

interface UiTooltipInfoProps {
  title: string;
  content: string | ReactNode;
  icon?: ReactNode;
}

export default function UiTooltipInfo({ icon, title, content }: UiTooltipInfoProps) {
  const preparedContent =
    typeof content === "string" ? (
      <SupText variant="subtitle1" as="div">
        {content}
      </SupText>
    ) : (
      content
    );

  return (
    <div className="space-y-2 text-neutral-900">
      <div className="inline-flex w-full flex-nowrap items-center space-x-1">
        {icon}
        <SupHeading variant="h6" weight="bold">
          {title}
        </SupHeading>
      </div>
      {preparedContent}
    </div>
  );
}
